// Webpack Imports
import * as bootstrap from "bootstrap";
import * as feather from "feather-icons";
import "./js/apriorit/nav-and-tabs";
import "./js/apriorit/yoast-schema-accordion";
import "./js/apriorit/search";
import "./js/apriorit/infinite-slider";
import "./js/apriorit/blog-sidebar";
import "./js/apriorit/main-menu";
import "./js/apriorit/accordion-slider";

(function ($) {
  "use strict";

  // Window width
  const currentWindowSize = window.innerWidth;
  // Window height
  let currentWindowHeight = window.innerHeight;

  // Focus input if Searchform is empty
  [].forEach.call(document.querySelectorAll(".search-form"), (el) => {
    el.addEventListener("submit", function (e) {
      var search = el.querySelector("input");
      if (search.value.length < 1) {
        e.preventDefault();
        search.focus();
      }
    });
  });

  // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  );
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl, {
      trigger: "focus",
    });
  });

  // Initialize Tooltips: https://getbootstrap.com/docs/5.0/components/tooltips/
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl, {
      trigger: "focus",
    });
  });

  
  // Add custom Twitter X icon
  feather.icons.twitterX = {
    name: "twitterX",
    contents:
      '<path d="M13.982 10.622 20.54 3h-1.554l-5.693 6.618L8.745 3H3.5l6.876 10.007L3.5 21h1.554l6.012-6.989L15.868 21h5.245l-7.131-10.378Zm-2.128 2.474-.697-.997-5.543-7.93H8l4.474 6.4.697.996 5.815 8.318h-2.387l-4.745-6.787Z"></path>',
    tags: ["custom"],
    attrs: {
      class: "feather feather-twitterX",
      xmlns: "http://www.w3.org/2000/svg",
      width: 24,
      height: 24,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      "stroke-width": 2,
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
    },
    toSvg: function (customAttrs) {
      let attrs = Object.assign({}, this.attrs, customAttrs);
      let attrString = Object.keys(attrs)
        .map((key) => `${key}="${attrs[key]}"`)
        .join(" ");
      return `<svg ${attrString}>${this.contents}</svg>`;
    },
  };
  // Init feather icons
  feather.replace();

  jQuery(document).ready(function () {
    /**
     * Open External links in new tab
     */
    const apAnchorsInMain = document
      .getElementById("main")
      .querySelectorAll("a");
    const apInternalDomains = [
      "local.apriorit.com",
      "dev.apriorit.com",
      "apriorit.com",
      "ebooks.apriorit.com",
      "webinars.apriorit.com",
      "apriorit.com",
    ];
    for (let i = 0; i < apAnchorsInMain.length; i++) {
      const currentHref = apAnchorsInMain[i].href;
      const containsInternalDomain = apInternalDomains.some((domain) =>
        currentHref.includes(domain)
      );

      if (
        !containsInternalDomain &&
        currentHref.search(/^(http:\/\/|https:\/\/|www\.)/) !== -1 &&
        currentHref.search(/^#/) === -1 &&
        apAnchorsInMain[i].hasAttribute("onClick") === false
      ) {
        apAnchorsInMain[i].setAttribute("target", "_blank");
        apAnchorsInMain[i].setAttribute("rel", "noopener noreferrer");
      }
    }

    let topics = jQuery(".single-post article").data("topics");

    if (typeof topics != "undefined" && topics !== null) {
      jQuery(".mc4wp-form-fields select option").each(function () {
        jQuery(this).attr("selected", false);

        let toFind = jQuery(this).text();

        if (toFind == "Quality Assurance") {
          toFind = "QA";
        }

        if (topics.indexOf(toFind) >= 0 && !jQuery(this).attr("selected")) {
          jQuery(this).attr("selected", true);
        }
      });
    }

    // Show modal button
    jQuery("#contact-form-anchor-btn").click(function () {
      const results = jQuery("#search-results"),
        resultsWrapper = results.find(".results-wrapper"),
        form = jQuery(".apriorit-search").find("form");

      if (form.is(":visible")) {
        jQuery(".apriorit-search .trigger button").toggleClass("show");
        jQuery(".ap-triangle-up").hide();
        jQuery("body").removeClass("search-results-shown");

        form.hide();
        resultsWrapper.html("");
        results.hide();
      }

      jQuery(".navbar-collapse").collapse("hide");
    });
  });

  jQuery(window).on("load", function () {

    jQuery(".book-time-slot").click(function () {
      Calendly.initPopupWidget({url: 'https://calendly.com/meet_apriorit_team'});
    });


    // Complianz Cookie Banner and Sales chat
    if (jQuery(window).width() < 768) {
      // if Cookie banner is visible hide Sales chat
      jQuery(document).on("cmplz_set_category_as_bodyclass", function (event) {
        // The cmplz_set_category_as_bodyclass event has dispatched
        jQuery("body").addClass("ap-hide-chat-bubbles");
      });

      // click on Cookie Banner
      jQuery(document).on(
        'click',
        '#cmplz-cookiebanner-container',
        function (event) {
          // Use setTimeout to run this after all changes has implemented and we can check visibility of cookie banner
          setTimeout(function () {
            if (jQuery("#cmplz-cookiebanner-container .cmplz-cookiebanner").is(":visible")) {
              jQuery("body").addClass("ap-hide-chat-bubbles");
            } else {
              jQuery("body").removeClass("ap-hide-chat-bubbles");
            }
          }, 1); // 0 is not enough! 
        }
      );
    }
  });

  jQuery("#category-check-all").click(function () {
    $(".category-check").prop("checked", $(this).prop("checked"));
  });

  var host = window.location.protocol + "//" + window.location.host;
  window.cookieconsent_options = {
    message:
      "Apriorit and selected trusted third parties use cookies on this site to improve performance, for analytics, and for re-marketing and re-targeting with relevant content. By browsing this site you are agreeing to this. For more information see our ",
    dismiss: "Close",
    learnMore: "Privacy Policy.",
    link: `${host}/privacy-policy`,
    theme: false,
  };

  const tabletSize = 992;

  if (currentWindowSize < tabletSize) {
    jQuery("#menu-main > .menu-item > .nav-link").on("click", function () {
      let currentLink = jQuery(this);

      jQuery("#menu-main > .menu-item > .nav-link")
        .not(currentLink)
        .find("+ .dropdown-menu .menu-item .dropdown-menu")
        .css({ display: "none" });
    });
  }

  jQuery(".navbar-collapse").on("show.bs.collapse", function () {
    const searchForm = jQuery("#apriorit-search .search-form");
    if (searchForm.is(":visible")) {
      jQuery("#apriorit-search button").toggleClass("show");
      const searchResults = jQuery("#search-results");
      resultsWrapper = searchResults.find(".results-wrapper");

      searchForm.hide();
      resultsWrapper.html("");
      searchResults.hide();
    }
  });

  jQuery(document).on("click", ".collapse-text", function () {
    let str = jQuery.trim(
      jQuery(this)
        .html()
        .split(
          '<i class="bi-chevron-double-right ms-3 align-middle " style="font-size: 12px;"></i>'
        )[0]
        .replace(/[\t\n]+/g, " ")
    );

    if (str === "Show more") {
      jQuery(this).html(
        'Show less <i class="bi-chevron-double-right ms-3 align-middle " style="font-size: 12px;"></i>'
      );
    } else {
      jQuery(this).html(
        'Show more <i class="bi-chevron-double-right ms-3 align-middle " style="font-size: 12px;"></i>'
      );
    }
  });

  /** Remove post thumbnail (entry-header-bg background) on scroll
   *  This is because blocks in the bottom  of article do not have background
   */
  const atricleThumbnail = jQuery("#entry-header-bg");
  if (atricleThumbnail.length) {
    jQuery(window)
      .on("load scroll", function () {
        if (jQuery(this).scrollTop() > currentWindowHeight) {
          atricleThumbnail.css("visibility", "hidden");
        } else {
          atricleThumbnail.css("visibility", "visible");
        }
      })
      .on("resize", function () {
        // If the user resizes the window
        currentWindowHeight = jQuery(this).height(); // Need the new height value
      });
  }

  /**
   *  Setting the AVAILABLE (minus controls height on mobile) height unit
   *  to access in CSS
   */
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  jQuery(window).on("scroll", function () {
    jQuery(".sticky-heading").each(function () {
        var elementTop = jQuery(this).offset().top;
        var elementBottom = elementTop + jQuery(this).outerHeight();
        var viewportTop = jQuery(window).scrollTop() + 400;
        var viewportBottom = viewportTop + (jQuery(window).height() / 10);

        if (elementTop < viewportBottom && elementBottom >= viewportTop) {
          jQuery(this).removeClass("faded");
        } else {
          jQuery(this).addClass("faded");
        }
    });
  });
})();